import { render, staticRenderFns } from "./PageBackend.vue?vue&type=template&id=6fc3bd68&"
import script from "./PageBackend.vue?vue&type=script&lang=js&"
export * from "./PageBackend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports